<template>
    <div class="contact">
      <Header
      :headerBgc="state.headerBgc"
      :showLogo="state.showLogo"
      :boxShadows="state.boxShadows"
      :title-color="state.titleColor"
      @titleClick="titleClick"
      @menuClick="menuClick"/>
      <div class="about_con">
        <div class="top">
          <p data-aos="fade-up" data-aos-duration="1000">{{ $t('contact.pageTitle') }}</p>
        </div>
        <div class="list">
          <div class="name yourButton" :class="state.active===index?'act':''" @click="handleList(index)" v-for="(item,index) in tabList" :key="item.id">{{item.name}}</div>
        </div>
        <!-- 联系我们 -->
        <div class="star_team" v-show="state.active===0">
            <img src="../assets/img/call.png" alt="">
        </div>
        <!-- 招贤纳士 -->
        <div class="com_call" v-show="state.active===1">
          <div class="job_box" v-for="(item,index) in state.jobList" :key="index">
            <div class="job_list" @click="jobDetail(index)" :class="state.jobImg===index?'bordert':''">
                <div class="one">{{ item.jd }}</div>
                <div class="three">
                    <div><span>{{ $t('contact.eduRequirement') }}：</span>{{ item.edu_back }}</div>
                    <div><span>{{ $t('contact.workExperience') }}：</span>{{ item.workTime }}</div>
                    <div><span>{{ $t('contact.headcount') }}：</span>{{ item.num }}</div>
                </div>
                <div class="four">
                    <div class="bb">{{ $t('common.learnMore') }}</div>
                </div>
            </div>
            <img class="jm" :src="item.img" v-if="state.jobImg===index" :class="state.jobImg===index?'mar':''" alt="">
          </div>
        </div>
      </div>
      <NewFooter />
    </div>
  </template>
  
  <script setup>
  import {reactive,onMounted,onUnmounted,ref,computed} from 'vue'
  import { useAppStore } from '../store/app'
  const router = useRouter()
  const route =useRoute()
  const { t } = useI18n()
  const localePath = useLocalePath()
  const { $aos } = useNuxtApp()
  const { activeNum,setActive } = useAppStore()

  useSeoMeta({
    title: t('contact.seoTitle'),
    description: t('contact.seoDescription'),
    ogTitle: t('contact.seoTitle'),
    ogDescription: t('contact.seoDescription'),
    ogType: 'website',
  })

  const tabList = computed(() => [
    { name: t('contact.contactUs'), id: 1 },
    { name: t('contact.recruit'), id: 2 },
  ])
 
  const state =  reactive({
    jobImg:-1,
    act:0,
    headerBgc: '',
    showLogo: true,
    titleColor: '#fff',
    boxShadows: '',
    active:0,
    actCom: 0,
    jobList:[
        {
            jd:'医学产品经理',
            num:'1',
            edu_back:'本科学历以上',
            workTime:'3-5年',
            img:'/job/1.png'
        },
        {
            jd:'博士后(肿瘤分子诊断试剂研发)',
            num:'1',
            edu_back:'博士',
            workTime:'3-5年',
            img:'/job/2.png'
        },
        {
            jd:'试剂研发经理',
            num:'1',
            edu_back:'硕士',
            workTime:'3-5年',
            img:'/job/3.png'
        },
        {
            jd:'销售总监',
            num:'1',
            edu_back:'大专',
            workTime:'3-5年',
            img:'/job/4.png'
        },
        {
            jd:'质量主管',
            num:'1',
            edu_back:'大专',
            workTime:'3-5年',
            img:'/job/5.png'
        },
        {
            jd:'IVD产品开发经理',
            num:'1',
            edu_back:'硕士',
            workTime:'3-5年',
            img:'/job/6.png'
        },
    ]
  })
  function jobDetail(index){
    state.jobImg=index
  }
  function proDetail(index){
      // state.headerBgc='#fff'
      // state.showLogo=false
      // state.titleColor="#000"
      // state.boxShadows='0px 1px 8px 0px rgba(0,0,0,0.09)'
      navigateTo(localePath(`/proDetail/${index}`))

  }
  function handleList(index){
    state.active=index
    setActive(index)
  }
  const titleClick=(id)=>{
    if (id == 11) {
    setActive(0)
      navigateTo(localePath(`/about`))
    }else if(id==22){
      setActive(0)
      navigateTo(localePath(`/product`))
    } else if (id == 33) {
      navigateTo(localePath(`/health`))
    } else if (id == 44) {
      setActive(0)
      navigateTo(localePath(`/contact`))
    } else {
      navigateTo(localePath(`/newsCenter`))
    }
  }
  const menuClick =(e,path)=>{
  let id = +e
    navigateTo(path)
    if(path.includes('/about')){
      setActive(+id-1)
      return
    }
    if(path.includes('/product')){
      state.active = id-6
      setActive(+id-6)
      return
    }
    if(path.includes('/health')){
      return
    }
    if(path.includes('/contact')){
      state.active = id-13
      setActive(+id-13)
      return
    }
}
function handleScroll() {
    let top = Math.floor(
      document.documentElement.scrollTop || document.body.scrollTop
    )
    if (top >= 80) {
      state.headerBgc = '#fff'
      state.showLogo = false
      state.titleColor = '#000'
      state.boxShadows = '0px 1px 8px 0px rgba(0,0,0,0.09)'
    } else {
      state.headerBgc = ''
      state.showLogo = true
      state.titleColor = '#fff'
      state.boxShadows = ''
    }
  }
  onMounted(()=>{
    const tab = Number(route.query.tab)
    state.active = (!isNaN(tab) && tab >= 0 && tab < tabList.value.length) ? tab : activeNum
    setActive(state.active)
      $aos().init({
        easing: 'ease-out-back',
        duration: 2000,
        once:true
    })
    window.addEventListener('scroll', handleScroll)
  })
  onUnmounted(()=>{
   window.removeEventListener('scroll', handleScroll)
   localStorage.removeItem('counter')
  })
  </script>
  
  <style lang="less" scoped>
  .contact{
    .about_con{
      width: 100%;
      background-color: #fff;
      position: relative;
      .top{
        // background: url('../assets/img/centext.png');
        background: url(https://img2.baidu.com/it/u=2293757504,4162084742&fm=253&fmt=auto&app=138&f=JPEG?w=1920&h=450);
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 200px;
        p{
          font-size: 18px;
          text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
          font-weight: 700;
          color: #fff;
          padding-top: 80px;
          text-align: center;
          // padding-left: 100px;
          transition: transform 0.3s ease, color 0.3s ease;
        }
        .p_act{
          transform: translateY(-30px); /* 鼠标经过时上移文字 */
          color: #333; /* 鼠标经过时加深文字颜色 */
        }
      }
      .list{
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.13);
        height: 34px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        .name{
          background-color: #fff;
          width: 120px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          cursor: pointer;
          color: #5A5A5A;
          transition: transform 0.3s ease, background-color 0.7s ease; /* 添加过渡效果 */
          &:hover{
            background-color: #00A0E9;
            color: #fff;
          }
        }
        .act{
          background-color: #00A0E9;
          color: #fff;
        }
      }
       // 企业介绍
      .com_desc{
        background: #F8F9FB;
        width: 100%;
        padding-top: 40px;
        padding-bottom: 100px;
        .prolist{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            width: 75%;
            border-bottom: 1px solid #E6E6E6;
            margin: auto;
            padding-bottom: 15px;
            padding-top: 15px;
            cursor: pointer;
            &:last-child{
                border-bottom: none;
            }
            &:hover{
                .l{
                    img{
                        transform: scale(1.1);
                        border: 1px solid #00A0E9;
                        border-radius: 6px;
                    }
                }
                .r{
                    .desc{
                        color: #00A0E9;
                    }
                }
            }
            .l{
                margin-right: 40px;
                width: 110px;
                height: 110px;
                img{
                    width: 100%;
                    height: 100%;
                    transition: transform 0.3s ease;
                }
            }
            .r{
               width: 55%;
               .name{
                font-size: 10px;
                color: #000;
                margin-bottom: 20px;
               }
               .desc{
                    color: #b5b6b6;
                    line-height: 16px;
               }
            }
        }
      }
      // 明星团队
      .star_team{
          width: 100%;
          padding-top: 60px;
          padding-bottom: 100px;
          background-color: #f8f9fb;
          text-align: center;
          img{
            width: 540px;
            max-width: 90%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        }
        .com_call{
            width: 100%;
            padding-top: 60px;
            padding-bottom: 100px;
            background-color: #f8f9fb;
            text-align: center;
           .job_box{
            .job_list{
                display: flex;
                align-items: center;
                background-color: #fff;
                width: 60%;
                margin: auto;
                margin-bottom: 20px;
                padding-top: 10px;
                box-sizing: border-box;
                .one{
                    flex: 3;
                    font-weight: bold;
                    color: #00A0E9;
                    text-align: center;
                }
                .three{
                    flex: 4;
                    text-align: center;
                    div{
                        margin-bottom: 10px;
                    }
                }
                .four{
                    flex: 3;
                    .bb{
                        width: 53px;
                        height: 18px;
                        border: 1px solid #00A0E9;
                        color: #00A0E9;
                        border-radius: 9px;
                        margin: auto;
                        line-height: 18px;
                        text-align: center;
                        margin-top: -5px;
                        cursor: pointer;
                        &:hover{
                            background-color: #00A0E9;
                            color: #fff;
                        }
                    }
                }
                span{
                    color: #999;
                }
            }
            .bordert{
                border-top: 2px solid #00A0E9;
            }
            .mar{
                margin-top: -20px;
                margin-bottom: 20px;
            }
            .jm{
               width: 60%;
               display: block;
               margin-left: auto;
               margin-right: auto;
            }
           }
        }
    }
  }
  </style>